<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteQuestionDialog"
    :title="t('deleteDialog.title')"
    :confirm-text="t('deleteDialog.confirm')"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>{{ t('deleteDialog.confirmMessage') }}</p>
      <div v-if="questionDescription" class="alert alert-light">
        <strong>{{ truncateText(questionDescription, 100) }}</strong>
      </div>
      <p class="text-danger">{{ t('deleteDialog.warning') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const baseDialog = ref(null);
const questionDescription = ref('');
const questionId = ref(null);

const open = (question) => {
  questionDescription.value = question.description;
  questionId.value = question.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = () => {
  emit('delete', questionId.value);
  baseDialog.value?.closeDialog();
};

const truncateText = (text, length) => {
  if (!text) return '';
  return text.length > length ? text.substring(0, length) + '...' : text;
};

defineExpose({ open });
</script>
